.int-amount {
  color: inherit;
}

.decimals {
  color: inherit;
}

.symbol {
  color: inherit;
}
